import * as React from 'react';
import styled from '@emotion/styled';
import { __ } from '../../helpers/TranslationService';
import { AreaIcon } from '../Icons/newIcons/AreaIcon';
import { UserIcon } from '../Icons/UserIcon';
import { BedIcon } from '../Icons/newIcons/BedIcon';
import { LevelIcon } from '../Icons/newIcons/LevelIcon';

interface IProps {
    title: string;
    descriptionText: string | string[];
}

const IconWrapper = styled.span`
    fill: ${({ theme }) => theme.icon.secondary};
    display: inline-block;
    width: 24px;
`;

const DescriptionInlineWrapper = styled.div`
    color: ${({ theme }) => theme.text.color.primary};
    font-size: 14px;
    display: flex;
`;

const DescriptionWrapper = styled.div`
    color: ${({ theme }) => theme.text.color.primary};
    font-size: 14px;
    margin: 24px 0;
`;

const DescriptionLabel = styled.span`
    font-weight: 700;
    display: flex;
    margin-right: 8px;
`;

const DescriptionList = styled.ul`
    list-style-type: disc;
    line-height: 22px;
    padding: 0;
    margin: 16px 0 0 0;
    > li {
        margin-bottom: 12px;
        margin-left: 8px;
        list-style-position: outside;
        padding-left: 1em;
        text-indent: -1em;
        &:before {
            content: '•';
            padding: 0 8px;
            margin-left: -8px;
        }
    }
`;

const getIconForLabel = (title: string) => {
    switch (title) {
        case 'Location':
            return (
                <IconWrapper>
                    <LevelIcon width={16} height={16} />
                </IconWrapper>
            );
        case 'Cabin size':
            return (
                <IconWrapper>
                    <AreaIcon width={16} height={16} />
                </IconWrapper>
            );
        case 'Occupancy':
            return (
                <IconWrapper>
                    <UserIcon width={14} height={16} />
                </IconWrapper>
            );
        case 'Bed':
            return (
                <IconWrapper>
                    <BedIcon width={16} height={14} />
                </IconWrapper>
            );
        default:
            return null;
    }
};

export function CabinDescription({ title, descriptionText }: IProps) {
    if (!descriptionText) {
        return null;
    }
    const isDescriptionArray = Array.isArray(descriptionText);

    if (isDescriptionArray && descriptionText.length === 0) {
        return null;
    }

    if (isDescriptionArray && descriptionText.length > 0) {
        const Items = descriptionText.map((item, index) => (
            <li key={`description-${index}`}>{item}</li>
        ));
        return (
            <DescriptionWrapper>
                <DescriptionLabel>{`${__(title, 'dreamlines')}: `} </DescriptionLabel>
                <DescriptionList>{Items}</DescriptionList>
            </DescriptionWrapper>
        );
    }

    return (
        <DescriptionInlineWrapper>
            <DescriptionLabel>
                {getIconForLabel(title)}
                {`${__(title, 'dreamlines')}: `}
            </DescriptionLabel>
            {descriptionText}
        </DescriptionInlineWrapper>
    );
}
